import { Theme } from "@mui/material/styles";

export const getChipComponents = (_sunoTheme: Theme) => ({
  MuiChip: {
    styleOverrides: {
      root: {
        color: "#000",
      },
      filled: {
        background: "rgba(199, 154, 235, 0.5)",
      },
    },
  },
});
